/**
 * @generated SignedSource<<7b5547c1915e36110165ff915b87d6b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VerifyEmailSignupPageResendMutation$variables = {
  id: string;
};
export type VerifyEmailSignupPageResendMutation$data = {
  readonly resendEmailSignupVerification: {
    readonly emailCanResendAt: string;
    readonly id: string;
  };
};
export type VerifyEmailSignupPageResendMutation = {
  response: VerifyEmailSignupPageResendMutation$data;
  variables: VerifyEmailSignupPageResendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "EmailSignupRequest",
    "kind": "LinkedField",
    "name": "resendEmailSignupVerification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailCanResendAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyEmailSignupPageResendMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyEmailSignupPageResendMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "55bc7ccc3379989181998b9da19d5519",
    "id": null,
    "metadata": {},
    "name": "VerifyEmailSignupPageResendMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyEmailSignupPageResendMutation(\n  $id: ID!\n) {\n  resendEmailSignupVerification(id: $id) {\n    id\n    emailCanResendAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d7f21f60c79f7a956f763bf5ddf983d";

export default node;
